"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERT_PER_USER_MAX = 50;
exports.MAX_INVALID_CONTEXT_DURATION = 35;
//# sourceMappingURL=constants.js.map